"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellEditor = void 0;
var React = require("react");
var react_popper_1 = require("react-popper");
var Localization_1 = require("../../../Localization");
var Modal_1 = require("../../../ReactPortalWrapper/Modal");
var Theme_1 = require("../../../Theme");
var CellEditor_styles_1 = require("./CellEditor.styles");
var getLabel = function (colDef, maxLength) {
    var baseString = Localization_1.strings
        .formatString(Localization_1.strings.CellEditor_Message_Input, colDef.headerName || Localization_1.strings.CellEditor_Label_UnknownName)
        .toString();
    if (maxLength) {
        return baseString + Localization_1.strings.formatString(Localization_1.strings.CellEditor_Message_MaxLength, maxLength.toString()).toString();
    }
    return baseString;
};
// This is a class because the CellEditorFramework needs getValue and we want afterGuiAttached to be implemented.
var CellEditor = /** @class */ (function (_super) {
    __extends(CellEditor, _super);
    function CellEditor(props) {
        var _this = _super.call(this, props) || this;
        // This is an ag-grid method
        _this.getValue = function () {
            // If the cell value is required and it is empty then return the original value so it restores.
            if (_this.props.ValueRequired && _this.state.Value.length === 0) {
                return _this.props.value;
            }
            return _this.state.Value;
        };
        _this.handleChange = function (event) {
            _this.setState({ Value: event.target.value });
        };
        _this.buildInlineMessage = function () {
            if (_this.props.ValueRequired && _this.state.Value.length === 0) {
                return _this.buildPopper(React.createElement(CellEditor_styles_1.P, { "aria-live": "assertive" }, Localization_1.strings.CellEditor_Validation_Required));
            }
            else if (_this.props.MaxLength) {
                return _this.buildPopper(React.createElement(CellEditor_styles_1.P, { "aria-hidden": true }, Localization_1.strings.formatString(Localization_1.strings.CellEditor_Validation_MaxLength, _this.state.Value.length.toString(), _this.props.MaxLength.toString())));
            }
            return null;
        };
        _this.buildPopper = function (message) {
            return (React.createElement(Modal_1.Modal, { DisableAutoFocus: true },
                React.createElement(react_popper_1.Popper, { placement: "bottom" }, function (_a) {
                    var ref = _a.ref, style = _a.style, placement = _a.placement;
                    return (React.createElement(CellEditor_styles_1.ValidationContainer, { ref: ref, style: __assign(__assign({}, style), { zIndex: Theme_1.portalsZIndex }), "data-placement": placement, Width: _this.myInput.current ? _this.myInput.current.clientWidth.toString() + "px" : undefined },
                        React.createElement(CellEditor_styles_1.TextContainer, null, message)));
                })));
        };
        _this.state = {
            Value: props.value,
        };
        _this.myInput = React.createRef();
        return _this;
    }
    // This is an ag-grid method
    CellEditor.prototype.afterGuiAttached = function () {
        if (this.myInput.current) {
            this.myInput.current.select();
        }
    };
    CellEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_popper_1.Manager, null,
            React.createElement(react_popper_1.Reference, null, function (_a) {
                var ref = _a.ref;
                return (React.createElement("div", { ref: ref },
                    React.createElement(CellEditor_styles_1.CellInput, { "aria-label": getLabel(_this.props.colDef, _this.props.MaxLength), type: "text", value: _this.state.Value, onChange: _this.handleChange, ref: _this.myInput, maxLength: _this.props.MaxLength })));
            }),
            this.buildInlineMessage()));
    };
    return CellEditor;
}(React.PureComponent));
exports.CellEditor = CellEditor;
